import { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Loader, Stack } from "components";
import AppointmentsRoutes from "./AppointmentsRoutes";
import App from "../App";

const Home = lazy(() => import("pages/Home"));
const Profile = lazy(() => import("pages/Profile"));
const EditProfile = lazy(() => import("pages/EditProfile"));
const ConsultNow = lazy(() => import("pages/ConsultNow"));
const ConsultLater = lazy(() => import("pages/ConsultLater"));
const Call = lazy(() => import("pages/Call"));

const AppRoutes = () => {
  const fallback = (
    <App>
      <Stack
        placeContent="center"
        placeItems="center"
        style={{ height: "100vh" }}
      >
        <Loader overlay={false} />
      </Stack>
    </App>
  );

  return (
    <Router>
      <Suspense fallback={fallback}>
        <Routes>
          <Route element={<App />}>
            <Route path="*" element={<Navigate to="" />} />
            <Route index element={<Home />} />
            <Route path="profile" element={<Profile />} />
            <Route path="profile/edit" element={<EditProfile />} />
            <Route path="consult-now" element={<ConsultNow />} />
            <Route path="consult-later" element={<ConsultLater />} />
            <Route path="call/:id" element={<Call />} />
            {AppointmentsRoutes}
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;
